// Transactions RBAC (2026-08-19) — mirrors backend server.py _allowed_for()
// exactly. TXN_ADM/INQ/APV/PAY come from userauth grants; SUPER client is
// an automatic full-CRUD escape hatch.
export const ALL_TXN_FIELDS = new Set([
  "txn_inv", "txn_amt", "txn_chk", "txn_note",
  "req_init", "pye_id", "codes_id", "pay_tp", "pay_dt", "post_dt",
]);

export function txnGrants(profile) {
  const fns = profile?.functions || [];
  return new Set(fns.filter((f) => f.startsWith("TXN_")));
}

export function isSuperUser(profile) {
  return !!profile?.is_super;
}

export function canSeeTransactions(profile) {
  return isSuperUser(profile) || txnGrants(profile).size > 0;
}

export function canCreateTransaction(profile) {
  const g = txnGrants(profile);
  return isSuperUser(profile) || g.has("TXN_ADM") || g.has("TXN_APV") || g.has("TXN_PAY");
}

// Returns { editable: Set<field>, allowedPayTps: Set<number>|null }
// null allowedPayTps = no restriction beyond the field set (Admin/SUPER).
export function permissionsFor(txn, profile) {
  const grants = txnGrants(profile);
  const isSuper = isSuperUser(profile);
  const isCreator = txn.created_by === profile?.user_id;
  const pt = Number(txn.pay_tp);

  if (isSuper || grants.has("TXN_ADM")) {
    return { editable: ALL_TXN_FIELDS, allowedPayTps: null };
  }

  const writeCapable = grants.has("TXN_APV") || grants.has("TXN_PAY");

  if ((pt === 0 || pt === 2) && isCreator && writeCapable) {
    return { editable: ALL_TXN_FIELDS, allowedPayTps: new Set([0]) };
  }
  if ([0, 1, 2].includes(pt) && grants.has("TXN_APV") && !isCreator) {
    return { editable: new Set(["pay_tp"]), allowedPayTps: new Set([1, 2]) };
  }
  if (pt === 1 && grants.has("TXN_PAY")) {
    return { editable: ALL_TXN_FIELDS, allowedPayTps: new Set([3, 4, 5, 6]) };
  }
  return { editable: new Set(), allowedPayTps: new Set() };
}

export function canDeleteTxn(txn, profile) {
  const grants = txnGrants(profile);
  if (isSuperUser(profile) || grants.has("TXN_ADM")) return true;
  const writeCapable = grants.has("TXN_APV") || grants.has("TXN_PAY");
  return writeCapable && txn.created_by === profile?.user_id && Number(txn.pay_tp) === 0;
}
